import { type FeedbackProps, Button, Feedback } from '@stone-payments/jade'
import BlackBird from 'shared/blackbird'
import { type ForbiddenErrorAction, type ForbiddenErrorStateInfo } from 'shared/child-resource-forbidden-store'
import { openWhatsAppSupport } from 'shared/navigation'

interface ChildResourceForbiddenScreenProps {
  info: ForbiddenErrorStateInfo
}

function runAction(action: ForbiddenErrorAction) {
  if (action.kind === 'help') {
    openWhatsAppSupport()
    return
  }

  if (typeof window !== 'undefined' && window.history.length > 1) {
    BlackBird.back()
    return
  }
  BlackBird.goHome()
}

export function ChildResourceForbiddenScreen({ info }: ChildResourceForbiddenScreenProps) {
  return (
    <div className="flex items-center justify-center" style={{ height: '80dvh' }}>
      <div className="flex" style={{ maxWidth: '400px' }}>
        <Feedback
          variant={info.variant}
          icon={info.icon as FeedbackProps['icon']}
          title={info.title}
          description={info.description}
        >
          <Button variant={info.secondaryAction.variant} onClick={() => runAction(info.secondaryAction)}>
            {info.secondaryAction.label}
          </Button>
          <Button variant={info.primaryAction.variant} onClick={() => runAction(info.primaryAction)}>
            {info.primaryAction.label}
          </Button>
        </Feedback>
      </div>
    </div>
  )
}
